import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions } from '../../../store/actions'
import history from '../../../route/history'

/**
 * 구매확인서 5단계 / 확인기관, 전자서명
 */
const CertificateStep04 = (props) => {
  // const [docid, setDocid] = useState() => 사용안해서 주석처리함 2022-05-04
  // const [docSeq, setDocSeq] = useState() => 사용안해서 주석처리함 2022-05-04
  const [state, setState] = useState({
    code: 'KTNET',
    organization: '한국무역정보통신',
  })

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      if (data.step2.length <= 0 || data.step3.length <= 0 || data.step4.length <= 0) {
        history.replace('/service/apply/1?id=' + id)
        return
      }
      // setDocid(id) => 사용안해서 주석처리함 2022-05-04
      // setDocSeq(data.step1.crtIssueSeq) => 사용안해서 주석처리함 2022-05-04
    } else {
      history.replace('/service/apply/1')
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  return (
    <React.Fragment>
      <div className=" m-t-20">
        <p className="sub-dec">
          신청업체는 전자무역촉진에관한 법률 시행규정 제7조에 의거 첨부근거서류를 5년동안 보관하셔야 합니다.
          <br />
          보관은 마이크로 필름, 광디스크, 전자문서보관소 등에 의해서도 보관할 수 있습니다.
          <br />
          <br />
          (위의 사항을 대외무역법 제18조에 따라 신청합니다.)
        </p>
      </div>

      <div className="step-title m-t-20 m-b-10">확인기관</div>
      <div className="lineBox m-t-20">
        <div className="flex-l m-b-15 stepEnd-infor ">
          <label className="name"> 코드</label>
          <input
            type="text"
            className="form-control input-text disabled"
            id="code"
            name="code"
            value={state.code}
            readOnly={true}
            title={'코드'}
          />
        </div>
        <div className="flex-l m-b-15 stepEnd-infor ">
          <label>기관명</label>
          <input
            type="text"
            className="form-control input-text disabled"
            id="organization"
            name="organization"
            value={state.organization}
            readOnly={true}
            title={'기관명'}
          />
        </div>
      </div>
      <div className="detail-btn">
        <button className="btn btn-white float-l" onClick={props.doDelete}>
          삭제
        </button>
        <button className="btn btn-blue" onClick={() => history.goBack()}>
          이 전
        </button>
        <button className="btn btn-dark-blue" onClick={props.doIssue}>
          발급신청
        </button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step3,
    totalData: state.contracter.data,
    isCalled: state.contracter.isCalled,
  }
}

const actionCreators = {
  setCalled: contracterActions.setCalled,
  alert: contracterActions.alert,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertificateStep04)
